import { Globe, Users, Handshake, TrendingUp } from 'lucide-react';
import { FadeInUp } from '../animations';

const brandBlocks = [
  { icon: <Globe size={28} strokeWidth={1.5} />, title: 'Global Reach', description: 'Access to Indian manufacturing opportunities across multiple product categories.' },
  { icon: <Users size={28} strokeWidth={1.5} />, title: 'Genuine Buyer Focus', description: 'We begin with the buyer\'s product, quantity, quality and commercial requirements.' },
  { icon: <Handshake size={28} strokeWidth={1.5} />, title: 'Long-Term Relationships', description: 'We focus on building reliable buyer\u2013manufacturer relationships.' },
  { icon: <TrendingUp size={28} strokeWidth={1.5} />, title: 'Mutual Growth', description: 'Creating sustainable opportunities for buyers and Indian manufacturers.' },
];

const BrandIntroSection = () => (
  <section className="py-24 lg:py-32 bg-white" data-testid="brand-intro">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <FadeInUp className="text-center mb-16">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#0B2A57] mb-4" style={{ fontFamily: 'Cabinet Grotesk' }}>
          YOUR INDIA SOURCING PARTNER.
        </h2>
        <p className="text-base text-[#6B7280] leading-relaxed max-w-3xl mx-auto">
          Taiga Sourcing works with international buyers to identify suitable Indian manufacturing partners and coordinate the sourcing journey from product requirement to shipment.
        </p>
      </FadeInUp>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {brandBlocks.map((block, i) => (
          <FadeInUp key={block.title} delay={i * 0.1}>
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-[#E5E0D8] text-[#0B2A57] mb-4">
                {block.icon}
              </div>
              <h3 className="text-sm font-semibold tracking-wider uppercase text-[#0B2A57] mb-2">{block.title}</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">{block.description}</p>
            </div>
          </FadeInUp>
        ))}
      </div>
    </div>
  </section>
);

export default BrandIntroSection;
